import { Flex, Typography } from '@banhala/ui-kit';
import { Pressable, View } from 'react-native';
import React from 'react';

type Props = {
  isEditMode: boolean;
  onEdit: () => void;
  onClose: () => void;
  onClearAll: () => void;
};

export const RecentHeader = ({
  isEditMode,
  onEdit,
  onClose,
  onClearAll,
}: Props) => {
  return (
    <Flex.Row
      alignItems="center"
      justifyContent="space-between"
      padding={{ horizontal: 16 }}
      height={44}
    >
      {/* 큰 글꼴 설정 기기(Android allowFontScaling)에서 텍스트 확대로 개행되는 것 방지 (ENABLE-1109) */}
      <Typography type="subtitle1" numberOfLines={1}>
        최근 검색어
      </Typography>
      <Flex.Row alignItems="center">
        {isEditMode ? (
          <>
            <Pressable onPress={onClearAll}>
              <Typography type="body3" color="content_secondary" numberOfLines={1}>
                전체삭제
              </Typography>
            </Pressable>
            <View
              style={{
                width: 1,
                height: 14,
                backgroundColor: '#D8D8D8',
                marginHorizontal: 8,
              }}
            />
            <Pressable onPress={onClose}>
              <Typography type="body3" color="content_secondary" numberOfLines={1}>
                닫기
              </Typography>
            </Pressable>
          </>
        ) : (
          <Pressable onPress={onEdit}>
            <Typography type="body3" color="content_secondary" numberOfLines={1}>
              편집
            </Typography>
          </Pressable>
        )}
      </Flex.Row>
    </Flex.Row>
  );
};
